/*
 * @Author: 流荧 lw427032@digital-engine.com
 * @Date: 2024-08-24 15:44:08
 * @LastEditors: 流荧 lw427032@digital-engine.com
 * @LastEditTime: 2024-09-06 14:54:37
 * @Description:
 */
/* eslint-disable */
// 该文件由 OneAPI 自动生成，请勿手动修改！
import { get, post } from "../../request/request";
//获取未读取消息接口
export async function getDict(dictType: string) {
  return get("/tenant-h5-platform/common/dict/data/get", {
    dictType,
  });
}
// 获取组织部门
export async function getAdminstrative(params: {
  searchTxt?: string;
  value?: string;
  pageNo?: number;
  pageSize?: number;
}) {
  return get("/tenant-pc/platform/administrativeOrg/listOption", {
    searchTxt: params?.searchTxt||'',
    value: params?.value||'',
    pageNo: params?.pageNo,
    pageSize: params?.pageSize,
  });
}

// 获取人员
export async function getUserList(params: {
  searchTxt?: string;
  value?: string;
  pageNo?: number;
  pageSize?: number;
}) {
  return get("/tenant-pc/platform/user/listOption", {
    searchTxt: params?.searchTxt||'',
    value: params?.value||'',
    pageNo: params?.pageNo,
    pageSize: params?.pageSize,
  });
}
